import { createAction, props } from '@ngrx/store';

export const loadAdvisorList = createAction('[Advisor] Load List');

export const loadAdvisorListSuccess = createAction(
  '[Advisor] Load List Success',
  props<{ data: any[] }>()
);

export const loadAdvisorListFailure = createAction(
  '[Advisor] Load List Failure',
  props<{ error: any }>()
);

export const clearAdvisorList = createAction('[Advisor] Clear List');
